import React, { ReactNode } from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import clsx from 'clsx'

interface ListWrapperProps {
  styles?: { root: string },
  children: ReactNode
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${theme.menuHeight}px)`,
    width: '100%',
  },
}))

const ListWrapper = (props: ListWrapperProps) => {
  const classes = useStyles()
  const { children, styles } = props

  const rootClass = clsx(classes.root, styles?.root && styles.root)
  return (
    <div className={rootClass}>
      {children}
    </div>
  )
}

export default ListWrapper
